import { api } from "@/services/api"
import { queryClient } from "@/queryClient"

export const logOut = async () => {
  await api.post("/session-logout/")
  queryClient.invalidateQueries({
    queryKey: [CURRENT_USER_QUERY_KEY],
  })
}
